import { message } from "antd"
import PropTypes from "prop-types"
import React, { useState } from "react"
import { useHistory, useLocation } from "react-router-dom"
import styled from "styled-components"

import * as api from "../../../../api/"
import AppButton from "../../../_shared/components/AppButton"
import AppInput from "../../../_shared/components/FormItems/AppInput"
import Paragraph from "../../../_shared/components/Typography/Paragraph"
import ScreenTitle from "../../../_shared/components/Typography/ScreenTitle"
import { useStateValue } from "../../../_shared/context/AppStateStore"

// ----------------------------------------------------------------------------

function UserAuthPage(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    // -------------------------------------
    // Hooks (e.g. useState, useMemo ...)
    // -------------------------------------

    const [code, setCode] = useState()
    const [, dispatch] = useStateValue()

    const location = useLocation()
    const history = useHistory()

    const params = new URLSearchParams(location.search)
    const succesRedirect = decodeURIComponent(
        params.get("success-redirect") || "/"
    )

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    async function handleAuth() {
        try {
            const { user, token } = await api.validateAndCreateUser(code)

            dispatch({
                type: "SIGN_IN_FULFILLED",
                payload: { user, token },
            })

            history.push(succesRedirect || "/")
        } catch {
            message.error("Inserire un codice fiscale valido.")
        }
    }

    function handleChange(e) {
        setCode(e.target.value?.toUpperCase())
    }

    function renderFormCard() {
        return (
            <div className="code-form">
                <div className="row">
                    <div className="input">
                        <AppInput
                            label="Codice fiscale"
                            value={code}
                            onChange={handleChange}
                        />
                    </div>
                    <AppButton
                        className="submit-btn"
                        uxType="primary"
                        htmlType="button"
                        onClick={handleAuth}
                    >
                        Invia
                    </AppButton>
                </div>
            </div>
        )
    }

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <div className={props.className}>
            <main>
                <div className="content">
                    <ScreenTitle
                        className="screen-title"
                        text={`Inserisci il tuo codice fiscale`}
                    />
                    <Paragraph className="paragraph">
                        In questo modo potrai accedere alla prenotazione degli
                        eventi e verificare gli orari disponibili per ciascuno
                        di essi.
                    </Paragraph>
                    {renderFormCard()}
                </div>
            </main>
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

UserAuthPage.propTypes = {
    className: PropTypes.string.isRequired,
}

UserAuthPage.defaultProps = {}

// ----------------------------------------------------------------------------

const StyledUserAuthPage = styled(UserAuthPage)`
    & {
        max-width: 100vw;
        width: 100vw;
        padding-bottom: 100px;
        overflow-x: hidden;
        main {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            flex-direction: column;
            width: 100%;

            .home-image {
                width: 100vw;
                max-width: 100vw;
                min-width: 100vw;
                overflow: hidden;
            }

            .content {
                width: 680px;
                .screen-title {
                    margin-top: 50px;
                    margin-bottom: 0;
                }
                .paragraph {
                    margin-top: 20px;
                    text-align: center;
                }
                .code-form {
                    height: 160px;
                    margin-top: 50px;
                    border-radius: 24px;
                    box-shadow: 0px 6px 35px 0px
                        ${({ theme }) => theme.colors.shadowColor};
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: center;
                    padding: 0px 70px;
                    .label {
                        font-size: 14px;
                        font-family: "Poppins-Bold";
                        text-transform: uppercase;
                    }
                    .row {
                        width: 100%;
                        display: flex;
                        flex-direction: row;
                        align-items: flex-end;
                        .input {
                            display: flex;
                            flex-grow: 1;
                            input {
                                width: 100%;
                            }
                        }
                        .submit-btn {
                            min-width: 190px;
                            margin-left: 17px;
                        }
                    }
                }
            }
        }
        @media (max-width: 980px) {
            main {
                .content {
                    width: 100vw;
                    min-width: 100vw;
                    max-width: 100vw;
                    word-wrap: break-word;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    padding: 0px 30px;
                    h1 {
                        max-width: 90%;
                        padding: 0px 10px;
                    }
                    .paragraph {
                        max-width: 80%;
                    }
                    .code-form {
                        width: 80%;
                        max-width: 100%;
                        height: 200px;
                        .row {
                            flex-direction: column;
                            align-items: center;
                            height: 100%;
                            justify-content: space-around;
                            .submit-btn {
                                margin: 0 !important;
                                width: 100%;
                            }
                            .input {
                                min-width: 190px;
                                flex-grow: unset;
                                width: 100%;
                                /* margin-bottom: 20px; */
                            }
                        }
                    }
                }
            }
        }

        @media (max-width: 768px) {
            main {
                max-width: 100vw;

                .content {
                    width: 100vw;
                    min-width: 100vw;
                    max-width: 100vw;
                    word-wrap: break-word;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    padding: 0px 0px;
                    .screen-title {
                        font-size: 40px;
                    }
                    .code-form {
                        width: 90%;
                        padding: 0px 30px;
                    }
                }
            }
        }
        @media (max-width: 576px) {
        }
    }
`
// ----------------------------------------------------------------------------

export default StyledUserAuthPage
